// Redux is a bit too much for what I'm trying to do here
// most of the operations are going to be server-side, so
// state management shouldn't be too complicated

import { createWithEqualityFn as create } from 'zustand/traditional';
import {devtools, subscribeWithSelector} from 'zustand/middleware';
import produce from 'immer';

const immer = (config) => (set, get, api) =>
  config(
    (partial, replace) => {
      const nextState = typeof partial === 'function' ? produce(partial) : partial;
      return set(nextState, replace);
    },
    get,
    api,
  );

const store = (set) => ({
  floatingNavHeight: 0,
  listviewScroll: 0,
  setFloatingNavHeight: (floatingNavHeight: string) => set({ floatingNavHeight }),
  setListViewScroll: (listviewScroll: string) => set({ listviewScroll }),
});

export const useStyleStore = create(subscribeWithSelector(devtools(immer(store))));
